/**
 * Labstep
 *
 * @module screens/User/Show/PersonalNotes
 * @desc User Personal Notes
 */

import { Can } from 'labstep-web/components/Entity/Can';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { ThreadModal } from 'labstep-web/components/Thread/Modal';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { IUserShowPersonalNotesProps } from './types';

export const UserShowPersonalNotes: React.FC<
  IUserShowPersonalNotesProps
> = ({ user, ...rest }) => (
  <Can action={Action.edit} entityName={user.entityName} id={user.id}>
    <ModalDefault
      header="Personal Notes"
      size="large"
      closeOnDimmerClick
      content={
        <ThreadModal
          noCommentsMessage="No personal notes"
          threadId={user.thread.id}
        />
      }
      {...rest}
    />
  </Can>
);
